import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export const projects = [
  {
    slug: 'marlin',
    title: 'marlin',
    description: 'software lead for the Marlin V2 autonomous submarine (3 yrs). placed 2nd & 5th at RoboSub International vs 40+ collegiate teams (MIT, Caltech, Cornell). built the cv pipeline and low-level firmware across PWM/UART/CAN/I2C.',
    link: 'https://www.avbotz.com/',
    tech: ['YOLO', 'python', 'c/c++', 'socket.io', 'ros2', 'opencv', 'gazebo', 'docker', 'cascaded pid'],
    status: 'completed',
    date: '2022-2025',
    perms: '-rw-r--r--',
  },
  {
    slug: 'marine-optimal-control',
    title: 'marine optimal control',
    description: 'MPPI optimal control for an 8-thruster auv — 100 rollouts x 5-step horizon, cutting path-tracking error 40% vs a PID baseline. + a linear kalman filter fusing gyro & accel for 3-axis orientation.',
    link: 'https://github.com/v2pir/Marine-Optimal-Control',
    tech: ['python', 'numpy', 'mppi', 'pid', 'kalman filter'],
    status: 'completed',
    date: '2024',
    perms: '-rw-r--r--',
  },
  {
    slug: 'veyra',
    title: 'veyra',
    description: '3d robotics simulation ide that fuses software + electrical simulation into one environment — real-time testing of electrical impulses, multi-computer communication, and physics. interest from 2 robotics startups, collegiate teams, and a research lab looking to license the electrical-sim capability.',
    link: 'https://veyra.vcwnsh.com',
    tech: ['c++', 'opengl', 'imgui', 'implot'],
    status: 'in progress',
    date: '2026',
    perms: 'drwxr-xr-x',
  },
  {
    slug: 'ieee-micromouse',
    title: 'ieee micromouse',
    description: 'designed and reflow-soldered a custom pcb in kicad for the UCLA micromouse competition (IEEE @ UCI); wrote a floodfill pathfinding script to navigate a 16x16 (256-cell) grid maze.',
    link: '',
    tech: ['kicad', 'c++', 'pcb design', 'reflow soldering', 'floodfill'],
    status: 'in progress',
    date: '2025-2026',
    perms: 'drwxr-xr-x',
  },
  {
    slug: 'syntari',
    title: 'syntari',
    description: 'blackjack trainer, teaches how to count cards (implemented hi-lo algo), training to memorize hands; 6 decks, reshuffles after 40% penetration of the deck.',
    link: 'https://syntari.vcwnsh.com',
    tech: ['tailwind', 'three.js', 'react', 'vite'],
    status: 'completed',
    date: '2025',
    perms: '-rw-r--r--',
  },
];

export default function Projects() {
  const [expanded, setExpanded] = useState(null);

  const handleClick = (slug) => {
    setExpanded(expanded === slug ? null : slug);
  };

  return (
    <div>
      {/* Prompt: ls -la projects/ */}
      <div className="prompt">
        <span className="p-user">vansh</span>
        <span className="p-sep">@</span>
        <span className="p-user">portfolio</span>
        <span className="p-sep">:</span>
        <span className="p-path">~/projects</span>
        <span className="p-char">$</span>
        <span className="p-cmd">ls -la</span>
      </div>

      <div className="output">
        <div className="total-line">total {projects.length}</div>
        {projects.map((project, i) => (
          <motion.div
            key={project.slug}
            initial={{ opacity: 0, y: 6 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.04, duration: 0.2 }}
          >
            <div
              className="file-row"
              role="button"
              tabIndex={0}
              aria-expanded={expanded === project.slug}
              onClick={() => handleClick(project.slug)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  handleClick(project.slug);
                }
              }}
            >
              <span className="f-perms">{project.perms}</span>
              <span className="f-size">{project.status === 'in progress' ? 'WIP' : '--'}</span>
              <span className="f-date">{project.date}</span>
              <span className="f-name">{project.title}</span>
            </div>

            <AnimatePresence>
              {expanded === project.slug && (
                <motion.div
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: 'auto' }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.2 }}
                  style={{ overflow: 'hidden' }}
                >
                  {/* cat prompt for expanded project */}
                  <div className="prompt" style={{ marginTop: 16, marginBottom: 4 }}>
                    <span className="p-user">vansh</span>
                    <span className="p-sep">@</span>
                    <span className="p-user">portfolio</span>
                    <span className="p-sep">:</span>
                    <span className="p-path">~/projects</span>
                    <span className="p-char">$</span>
                    <span className="p-cmd">cat {project.slug}</span>
                  </div>

                  <div className="project-detail">
                    <div className="content-title">{project.title}</div>
                    <div className="content-meta">
                      <span>{project.date}</span>
                      <span className="sep">·</span>
                      <span>{project.status}</span>
                    </div>
                    <div className="project-desc" style={{ marginTop: 16 }}>
                      {project.description}
                    </div>
                    <div style={{ marginBottom: 12 }}>
                      {project.tech.map((t) => (
                        <span key={t} className="tech-tag">{t}</span>
                      ))}
                    </div>
                    {project.link && (
                      <a
                        href={project.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="project-link"
                        onClick={(e) => e.stopPropagation()}
                      >
                        {project.link}
                      </a>
                    )}
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </motion.div>
        ))}
      </div>

    </div>
  );
}
